import useAuth from "../../../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import { CustomButton } from "../../../atoms/CustomButton";
import { useExportData } from "../../../../hooks/entity";
import { PlanTier, usePermissions } from "../../../../utils/permissions";
import { Cap, Level } from "../../../../utils/rbacCatalog";

const ExportData = () => {
  const [t] = useTranslation();
  const { customer_identification, user } = useAuth();
  const { mutate, isLoading } = useExportData();

  const permissions = usePermissions(user);

  const handleExportData = () => {
    mutate(
      {
        customer_identification: customer_identification,
        entity_identification: user.entity_identification,
      },
      {
        onSuccess: (data) => {
          const url = window.URL.createObjectURL(new Blob([data?.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "exportedData.csv");
          document.body.appendChild(link);
          link.click();
        },
      }
    );
  };

  const hasExportAccess = permissions.isAtLeastTier(PlanTier.ENTERPRISE);
  const canExport = permissions.can(Cap.EXPORT_DATA, Level.VIEW);

  return (
    <div className="flex w-full flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-sm text-gray-600">
        {hasExportAccess
          ? t("dashboard.develop.exportData.title-01")
          : t(
              "dashboard.develop.exportData.upgrade_required",
              "Upgrade to access data export feature"
            )}
      </p>

      <CustomButton
        variant={hasExportAccess ? "primary" : "secondary"}
        onClick={hasExportAccess && canExport ? handleExportData : undefined}
        disabled={!hasExportAccess || !canExport || isLoading}
        isLoading={hasExportAccess && isLoading}
        className="self-end sm:self-auto"
        title={
          hasExportAccess
            ? t("dashboard.develop.exportData.btn-01")
            : t("dashboard.develop.exportData.upgrade_btn", "Upgrade Plan")
        }
      />
    </div>
  );
};

export default ExportData;
